import { UpdateOrg } from 'domain/usecases/org/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteUpdateOrg implements UpdateOrg {
  private readonly url: string;

  private readonly httpClient: HttpClient<UpdateOrg.Model>;

  constructor(url: string, httClient: HttpClient<UpdateOrg.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  update = async (params: UpdateOrg.Params): Promise<UpdateOrg.Model> => {
    const { id, logo, ...rest } = params;
    const httpResponse = await this.httpClient.request({
      url: this.url.replace('{orgId}', `${id}`),
      body: logo ?? rest,
      headers: {
        'Content-Type': logo ? 'multipart/form-data' : 'application/json',
      },
      method: 'patch',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
